import React, { FC } from 'react'
import clsx from 'clsx'

import styles from './Divider.module.scss'
import { StandardProps } from '../../types/common'

interface DividerProps extends StandardProps {}

export const Divider: FC<DividerProps> = ({
  className,
  style,
  testid = 'divider',
}) => {
  return (
    <div
      className={clsx(styles['divider'], className)}
      style={style}
      data-testid={testid}
    ></div>
  )
}
